import { useCallback } from 'react';

import { normaliseUsername } from './auth-utils';

type ForgotPasswordParams = { username: string; organisationCode?: string };

const useForgotPassword = (apiUrl: string) =>
  useCallback(
    async ({ username, organisationCode }: ForgotPasswordParams): Promise<void> => {
      const response = await fetch(`${apiUrl}/auth/forgot-password`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: normaliseUsername(username),
          ...(organisationCode && { organisationCode }),
        }),
      });

      if (!response.ok) {
        throw new Error('forgot password failed');
      }
    },
    [apiUrl]
  );

type ConfirmForgotPasswordParams = {
  username: string;
  confirmationCode: string;
  password: string;
  organisationCode?: string;
};

const useConfirmForgotPassword = (apiUrl: string) =>
  useCallback(
    async ({ username, confirmationCode, password, organisationCode }: ConfirmForgotPasswordParams): Promise<void> => {
      const response = await fetch(`${apiUrl}/auth/confirm-forgot-password`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: normaliseUsername(username),
          confirmationCode,
          password,
          ...(organisationCode && { organisationCode }),
        }),
      });

      if (!response.ok) {
        throw new Error('confirm forgot password failed');
      }
    },
    [apiUrl]
  );

export type { ConfirmForgotPasswordParams, ForgotPasswordParams };

export { useConfirmForgotPassword, useForgotPassword };
